import callApi from '../../util/apiCaller';

import { getSubject, getSubjectOption } from '../Subject/SubjectActions';
import { checkVariables } from '../Subject/VariableActions';
import { getSessionOption } from '../Session/SessionActions';

// Export Constants
export const SET_PAGES = 'SET_PAGES';

export function getPagesRequest(subjectId) {
    return dispatch => {
        return callApi(`pages/${subjectId}`).then(result => {
            dispatch(setPages(subjectId, result.pages));
            return result.pages;
        }).catch(err => {
            return null;
        });
    };
}

export function editPageRequest(page, requestAll = true) {
    return dispatch => {
        return callApi('page/edit', 'post', { page }).then(result => {
            requestAll && result.page && dispatch(getPagesRequest(result.page.subject));
            return result.page;
        }).catch(err => {
            return null;
        });
    };
}

export function sortPagesRequest(subjectId, pages) {
    return dispatch => {
        return callApi('page/sort', 'post', { subject: subjectId, pages: (pages || []).map(page => ({ _id: page._id, sort: page.sort })) }).then(result => {
            return result.ok && dispatch(getPagesRequest(pages[0].subject));
            // return result.pages;
        }).catch(err => {
            return null;
        });
    };
}

export function removePageRequest(page) {
    return dispatch => {
        return callApi('page/remove', 'delete', { page: { _id: page._id } }).then(result => {
            dispatch(getPagesRequest(page.subject));
            return result.ok;
        }).catch(err => {
            return null;
        });
    };
}

// Getters
export function getPages(store, subjectId) {
    const subject = getSubject(store, subjectId);
    return ((subject && subject.pages) || []).sort((pageA, pageB) => pageA.sort - pageB.sort);
}

export function getPage(store, subjectId, id) {
    return getPages(store, subjectId).find(page => page._id === id);
}

export function getPageOption(page, option) {
    if(page && page.options) {
        return page.options[option];
    }
    return '';
}

export function getPageCompletionTime(page, subject, session = null) {
    if(session && getSessionOption(session, 'rewriteSubjectOptions')) {
        return parseInt(getSessionOption(session, 'pageCompletionTime'), 10);
    }
    return parseInt(getPageOption(page, 'pageCompletionTime') || getSubjectOption(subject, 'pageCompletionTime'), 10);
}

export function checkPageVariables(subject, page) {
    return checkVariables([page.label, page.content], subject.variables);
}

// Export Actions
export function setPages(subjectId, pages) {
    return {
        type: SET_PAGES,
        subjectId,
        pages,
    };
}
